import {axios as http} from "@/plugins/http"
import Helper from "@/services/Helper"

function getFormData(obj) {
    const formData = new FormData()

    Object.entries(obj).forEach(([key, val]) => {
        formData.append(key, val)
    })

    return formData
}

export default class Api {
    static count(typeIds, typeVisible) {
        let query = {}

        Object.entries(typeIds).forEach(([key, val]) => {
            query = Helper.mergeObject(query, {
                [`type_ids[${key}]`]: val
            })
        })

        query.type_visible = typeVisible

        return http.post("/api/v1/post/site/count-not-moderated", getFormData(query)).then((resp) => {
            return resp.data["count"]
        })
    }
}
